// IMPORTANTE: Este import debe estar PRIMERO para inicializar las variables de entorno
import './app/early-init';

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';


// Función para validar que las variables de entorno estén disponibles
function validateEnvironment(): boolean {
  const isValidEnv = !!(window['selfEnv'] && window['selfEnv'].trim());
  const isValidConfig = !!(window['selfPc'] && window['selfPc'].trim());

  if (isValidEnv && isValidConfig) {
    // console.log('✅ Validación final exitosa - Variables de entorno disponibles');
    return true;
  } else {
    // console.error('❌ Validación final fallida - Variables de entorno no disponibles');
    // console.error('selfEnv válido:', isValidEnv);
    // console.error('selfPc válido:', isValidConfig);
    return false;
  }
}

// Mostrar pantalla de error si las variables no están disponibles
function showErrorScreen(message: string): void {
  document.body.innerHTML = `
    <div style="
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      font-family: Arial, sans-serif;
      background-color: #f8f9fa;
    ">
      <div style="
        text-align: center;
        padding: 2rem;
        background: white;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        max-width: 600px;
      ">
        <h2 style="color: #dc3545; margin-bottom: 1rem;">
          <span style="font-size: 62px; font-weight: bold; display: block; margin-bottom: 10px;">⚠️</span>
          Error de Configuración
        </h2>
        <p style="color: #6c757d; margin-bottom: 1.5rem;">${message}</p>
        <button onclick="location.reload()" style="
          background-color: #007bff;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 16px;
          margin-right: 10px;
        ">
          🔄 Reintentar
        </button>
        <!-- <button onclick="console.log('DEBUG INFO:', {selfEnv: !!window.selfEnv, selfPc: !!window.selfPc})" style="
          background-color: #6c757d;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 16px;
        ">
          🔍 Debug Info
        </button> -->
      </div>
    </div>
  `;
}

// Validar e iniciar la aplicación
try {
  if (validateEnvironment()) {
    // Las variables están disponibles, iniciar la aplicación
    bootstrapApplication(AppComponent, appConfig)
      .then(() => {
        // console.log('🚀 Aplicación iniciada correctamente');
      })
      .catch((err) => {
        console.error('💥 Error al iniciar la aplicación:', err);
        showErrorScreen(`Error al iniciar la aplicación: ${err.message || 'Error desconocido'}`);
      });
  } else {
    // Las variables no están disponibles
    showErrorScreen('Las variables de configuración no están disponibles. Esto puede deberse a un problema de inicialización.');
  }
} catch (error) {
  // console.error('🚨 Error crítico durante la validación:', error);
  showErrorScreen(`Error crítico: ${error instanceof Error ? error.message : 'Error desconocido'}`);
}
